/**
 * Step scaffold for the public assessment. The real 20-block instrument
 * (Carmedix blueprint) is a later project; today there is ONE step — the
 * placeholder notice — so the page already walks a `steps` array and submits
 * a `result` at the end. Adding blocks later means adding steps here, not
 * restructuring the page.
 */
import type { PlaceholderResult } from './assess-api';

export type StepKind = 'notice';

export interface AssessmentStep {
  id: string;
  kind: StepKind;
  /** Short title for the progress label ("Step 1 of 1"). */
  title: string;
}

export const ASSESSMENT_STEPS: ReadonlyArray<AssessmentStep> = [{ id: 'notice', kind: 'notice', title: 'About this assessment' }];

/** Builds the `result` posted on completion. Today: the placeholder marker only. */
export function buildResult(): PlaceholderResult {
  return { placeholder: true };
}

export function isLastStep(index: number): boolean {
  return index >= ASSESSMENT_STEPS.length - 1;
}
